var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "billing-totals-container" },
    _vm._l(_vm.items, function (item, index) {
      return _c(
        "div",
        { key: index },
        [
          item.children
            ? _c(
                "v-expansion-panels",
                { attrs: { value: 0 } },
                [
                  _c(
                    "v-expansion-panel",
                    [
                      _c(
                        "v-expansion-panel-header",
                        [
                          _c("BillingTotalItemComponent", {
                            attrs: { item: item },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-expansion-panel-content",
                        _vm._l(item.children, function (child, index) {
                          return _c("BillingTotalItemComponent", {
                            key: index,
                            attrs: { item: child, isAccordionType: "" },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c("BillingTotalItemComponent", { attrs: { item: item } }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }